import { useCallback, useEffect, useRef } from 'react';
import { useGameStore } from '@/store/gameStore';
import { MainMenu } from '@/components/MainMenu';
import { PuzzleSelect } from '@/components/PuzzleSelect';
import { GameScreen } from '@/components/GameScreen';
import { audioEngine } from '@/audio/AudioEngine';
import { initAudioSubscription } from '@/audio/audioSubscription';
import { useReducedMotionSync } from '@/hooks/useReducedMotion';
import { initAnnouncer } from '@/accessibility/announcer';
import { initGameAnnouncements } from '@/accessibility/gameAnnouncements';
import { initSDK, signalGameReady, onPause, onResume, onMute } from '@/sdk/funway';

export function App() {
  const screen = useGameStore((s) => s.screen);
  const audioInitialized = useRef(false);

  useReducedMotionSync();

  useEffect(() => {
    if (!audioInitialized.current) {
      initAudioSubscription();
      initAnnouncer();
      initGameAnnouncements();
      audioInitialized.current = true;
    }

    // Funway SDK initialization and event handlers
    initSDK().then(() => {
      signalGameReady();
    }).catch(() => {
      // SDK init failed — game works standalone
    });

    onPause(() => {
      audioEngine.mute();
    });

    onResume(() => {
      // Resume — user will interact to unpause
    });

    onMute((muted) => {
      if (muted) audioEngine.mute();
      else audioEngine.unmute();
    });
  }, []);

  const handleFirstInteraction = useCallback(() => {
    if (!audioEngine.isReady()) {
      audioEngine.init();
    }
  }, []);

  return (
    <div
      onClick={handleFirstInteraction}
      onTouchStart={handleFirstInteraction}
      style={{
        width: '100%',
        height: '100%',
        background: '#0A0A1A',
        overflow: 'hidden',
      }}
    >
      {screen === 'menu' && <MainMenu />}
      {screen === 'puzzleSelect' && <PuzzleSelect />}
      {screen === 'game' && <GameScreen />}
    </div>
  );
}
